// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'FrederickSimms', 'FrederickSimms Fallback', Objektiv, sans-serif"},"className":"__className_6d8918","variable":"__variable_6d8918"};